import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling down 500px
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-319">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 md:hidden" data-id="element-320">
          <div className="bg-white rounded-2xl shadow-[0_-10px_40px_rgba(0,0,0,0.1)] border border-caramel/20 p-4 flex items-center justify-between gap-4" data-id="element-321">
            <div className="flex flex-col" data-id="element-322">
              <span className="text-xs text-espresso-light line-through" data-id="element-323">
                $29.99
              </span>
              <span className="text-xl font-bold text-caramel leading-none" data-id="element-324">
                $14.99 USD
              </span>
            </div>
            <a href="#oferta" className="flex-1 bg-caramel text-white font-bold py-3 px-4 rounded-xl text-center text-sm flex items-center justify-center gap-2 active:scale-95 transition-transform" data-id="element-325">
              <ShoppingCart className="w-4 h-4" data-id="element-326" />
              ¡SÍ, LO QUIERO!
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}